import React, { useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';

const Account = observer(({ top, dispatchTop }) => {
  const { accountBalanceStore } = useWebsocketStore();
  return (
    <RenderAccountNumbers
      values={accountBalanceStore.balances}
      top={top}
      dispatchTop={dispatchTop}
    />
  );
});

export default Account;
/*
export default class Account1 extends React.Component {
  constructor(props) {
    super(props);
    this.observable = BalancesObservable;
    this.component = RenderAccountNumbers;
    this.state = { storedValues: {} };
  }

  componentDidMount() {
    this.subscription = this.observable.subscribe((value) =>
      this.setState({ storedValues: value })
    );
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  render() {
    const Component = this.component;
    return (
      <Component
        values={this.state.storedValues}
        top={this.props.top}
        dispatchTop={this.props.dispatchTop}
      />
    );
  }
}*/

function RenderAccountNumbers(props) {
  let top = props.top;
  let dispatchTop = props.dispatchTop;
  let accounts = [];
  let balances = props.values;

  useEffect(() => {
    if (top.brokerage === 'BACKTEST' && top.accountNumber !== 'BACKTEST') {
      dispatchTop({ accountNumber: 'BACKTEST' });
    }
  }, [top.brokerage]);

  if (balances !== undefined) {
    let accts = [];
    for (let accountId in balances) {
      if (accountId === 'BACKTEST') {
        continue;
      }
      let account = {
        accountId: accountId,
        nickname: balances[accountId].nickname,
      };
      accts.push(account);
    }

    //     let backtest = {
    //         accountId: "BACKTEST",
    //         nickname: "BACKTEST",
    //    }
    //     accts.push(backtest);
    accounts = accts;
  }
  return (
    <React.Fragment>
      <label>
        <Typography style={{ fontSize: 12 }}>Account #:</Typography>
      </label>
      {top.dataSource === 'SIMULATED' ||
      top.dataSource === 'REPLAY' ||
      (top.dataSource === 'LIVE' && top.brokerage === 'BACKTEST') ? (
        <label key="BACKTEST">
          <input
            type="radio"
            name="account"
            value="BACKTEST"
            checked={true}
            onChange={(ev) => dispatchTop({ accountNumber: ev.target.value })}
          />
          &nbsp;<Typography style={{ fontSize: 12 }}>SIM</Typography>
        </label>
      ) : (
        accounts.map((e) => (
          <label key={e.accountId}>
            <input
              type="radio"
              name="account"
              //value={e.nickname}
              checked={top.accountNumber === e.accountId}
              onChange={(ev) => dispatchTop({ accountNumber: e.accountId })}
            />
            <Typography style={{ fontSize: 12 }}>
              &nbsp;&nbsp;{e.nickname}
            </Typography>
          </label>
        ))
      )}
    </React.Fragment>
    /*
        <TextInput
          label="Account number:"
          placeholder="Please enter an account number..."

          value={top.accountNumber != null ? top.accountNumber : ""}
          onChange={(val) => dispatchTop({ accountNumber: val })}
        />
        */
  );
}
